import { Link } from 'react-router-dom'

function NotFound() {
	return (
		<div className='pt-[200px] flex flex-col items-center justify-center'>
			<p className='text-[18px] font-medium text-black dark:text-white'>
				Извините, страница не найдена!
			</p>
			<p className='mt-[15px] text-center text-dark-100 w-[320px]'>
				Не волнуйтесь, нажмите на большую оранжевую кнопку снизу для
				перехода на главную страницу.
			</p>
			<div className='flex w-full justify-center mt-[25px]'>
				<Link
					to='/'
					className='h-[54px] w-[234px] bg-yellow-100 flex items-center text-black dark:text-white justify-center text-[18px] font-medium'
				>
					Вернуться на главную
				</Link>
			</div>
		</div>
	)
}

export default NotFound
